module.exports = __webpack_public_path__ + "static/img/logo-dragonpass@2x.7bd2924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-dragonpass@2x.png
// module id = sw5V
// module chunks = 1